<script setup>
import { onBeforeUnmount, ref } from 'vue';
import { Events } from '../events';

  const toast = ref(null)
  Events.listen(Events.TOAST, e => {
    toast.value = e.detail
    setTimeout(() => toast.value = null, 3000)
  })
  const listenerGroup = Events.group();

  onBeforeUnmount(() => {
    listenerGroup.dispose()
  });

  const ToastClasses = {
    error: 'alert-error text-error-content'
  }

</script>
<template>
  <div class="toast toast-top toast-center" style="z-index: 9999;" v-if="toast">
    <div :class='`alert ${ToastClasses[toast.kind]}`'>
      <span>{{ toast.text }}</span>
    </div>
  </div>


</template>